module.exports = __webpack_public_path__ + "img/download.0ff1cadb.jpg";